import { useQuery } from "react-query";
import { AllDivisiActiveResponse } from "../../../../models/Divisi";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllActiveDivisiKey = "all-active-divisi-key";

export async function fetchAllActiveDivisi(): Promise<
  AllDivisiActiveResponse[]
> {
  const res = await ApiClient.get(`/AllActiveDivisi`);
  return res.data;
}

export default function useFetchAllActiveDivisi() {
  return useQuery(
    [fetchAllActiveDivisiKey],
    queryWrapper(fetchAllActiveDivisi)
  );
}
